import { Record } from 'immutable';
import { UNINITIALIZED } from '../constants/asyncStatuses';
export const AsyncDataRecord = ({
  data
}, name) => class extends Record({
  state: UNINITIALIZED,
  error: null,
  data
}, name) {};